<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Category</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item">
                                <Link :href="route('admin.categories.index')">
                                    Category
                                </Link>
                            </li>
                            <li class="breadcrumb-item active">{{ isEditing ? "Edit" : "Add" }} Category
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">

                <div class="card-body">
                    <form @submit.prevent="saveCategory" enctype="multipart/form-data">
                        <div class="row">
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Category Name</label>
                                        <input type="text" v-model="category.name" class="form-control"
                                               placeholder="Category Name"
                                               required>
                                        <div v-if="category.errors.name" class="text-danger text-small">
                                            {{ category.errors.name }}
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="controls">
                                        <label class="form-label">Parent Category</label>
                                        <select v-model="category.parent_id" id="" class="form-control">
                                            <option :value="null">Select a Parent Category</option>
                                            <option v-for="category in categories" :key="category.id"
                                                    :value="category.id">
                                                {{ category.name }}
                                            </option>
                                        </select>
                                        <span v-if="category.errors.parent_id"
                                              class="text-danger text-small">{{ category.errors.parent_id }}</span>
                                    </div>
                                </div>
<!--                                <div class="form-group">-->
<!--                                    <div class="controls">-->
<!--                                        <label>Category Image</label>-->
<!--                                        <template v-if="this.category.image.hasOwnProperty('image')">-->
<!--                                            <div class="row">-->
<!--                                                <div class="col-3">-->
<!--                                                    <a :href="category.image.image" target="_blank">-->
<!--                                                        <img :src="category.image.image_thumbnail"-->
<!--                                                             :alt="category.name +' Image'"-->
<!--                                                             class="img-thumbnail img-fluid"-->
<!--                                                             style="height: auto; max-width:130px; vertical-align: middle; width: 100%;">-->
<!--                                                    </a>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </template>-->
<!--                                        <button type="button" data-toggle="modal" data-target="#gallery-modal"-->
<!--                                                class="form-control"> {{ category.image ? 'Change' : 'Choose' }}-->
<!--                                            Category Image-->
<!--                                        </button>-->
<!--                                    </div>-->
<!--                                </div>-->
                            </div>

                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Category Index</label>
                                        <input type="text" v-model="category.index" class="form-control"
                                               placeholder="Category Index">
                                        <div v-if="category.errors.index" class="text-danger text-small">
                                            {{ category.errors.index }}
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 col-sm-6">
                                    <div class="form-group">
                                        <div class="controls">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox"
                                                       v-model="category.status"
                                                       id="defaultCheck1"
                                                       :true-value="true" :false-value="false">
                                                <label class="form-check-label" for="defaultCheck1">
                                                    Is this Category Active?
                                                </label>
                                            </div>
                                            <span v-if="category.errors.status"
                                                  class="text-danger text-small">{{ category.errors.status }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-1">
                                <button type="submit" class="btn btn-primary glow mb-1 mb-sm-0 mr-0 mr-sm-1"
                                        :disabled="saving">
                                    {{ isEditing ? 'Update' : 'Save' }}
                                    <i class="fa fa-spinner fa-spin" v-if="saving"/>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
        </div>
<!--        <gallery-modal @chooseImage="chosenImage" gallery-header="Select Image for Category"></gallery-modal>-->
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from "@inertiajs/vue2";
import GalleryModal from "../../../Shared/GalleryModal";

export default {
    metaInfo: {title: 'Create Category'},
    name: 'CategoryCreate',
    props: [
        'categories',
        'isEditing',
        'categoryData',
    ],
    components: {
        Link,
        // GalleryModal
    },
    layout: Layout,
    data() {
        return {
            category: this.$inertia.form({
                name: null,
                parent_id: null,
                // image: {},
                status: false,
                index: null,
            }),
            saving: false
        }
    },
    methods: {
        // chosenImage(image) {
        //     if (this.category.hasOwnProperty('image')) {
        //         this.category.image = image;
        //     }
        // },
        async saveCategory() {
            this.saving = true;
            const options = {
                preserveScroll: true,
                onSuccess: () => this.saving = false,
                onError: () => {
                    this.saving = false;
                }
            };

            // this.category.image = this.category.image.image;
            if (this.isEditing) {
                this.category.put(route('admin.categories.update', this.categoryData.id), options);
            } else {
                this.category.post(route('admin.categories.store'), options);
            }
        }
    },
    mounted() {
        if (this.isEditing) {
            this.category.name = this.categoryData.name;
            this.category.parent_id = this.categoryData.parent_id;
            this.category.status = this.categoryData.status;
            // this.category.image =  {
            //     image: this.categoryData.image_url,
            //     image_thumbnail: this.categoryData.image_url
            // };
            this.category.index = this.categoryData.index;
            // this.metaInfo.title = 'Update Categories';
        }
    },
}
</script>
